<template>
  <div class="right-box">
    <div>
      <div class="right-box-left">
        <div style="margin-top: 43px;" class="top">
          <div class="avatar">
            <img
              v-if="accountData.avatar"
              :src="accountData.avatar"
              :onerror="defaultAvatarImgae"
            />
            <img v-else src="../../assets/imgs/hello.png" />
            <el-upload
              name="image"
              :action="actionadd()"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload"
            >
              <span> <img src="../../assets/imgs/camera.png" />更换头像 </span>
            </el-upload>
          </div>
          <div class="intro">
            <span class="nikename">{{ leftnikename }}</span>
            <span class="spanbox">
              <span v-if="modifyIntroShow">{{
                accountData.little_intro
                  ? accountData.little_intro
                  : "芯无止境，积微成著"
              }}</span>
              <el-input
                id="inputVal"
                maxlength="10"
                @blur="modifyIntroHide"
                v-model="accountData.little_intro"
                v-else
              ></el-input>
              <img
                v-show="modifyIntroShow"
                @click="modifyIntro"
                src="../../assets/imgs/tianxie.png"
              />
            </span>
          </div>
        </div>
        <div class="bottom">
          <span>
            <img src="../../assets/imgs/commpany_people.png" />
            {{ leftnikename }}
          </span>
          <span>
            <img src="../../assets/imgs/commpany_cc.png" />
            {{ accountData.company_name }}
          </span>
          <span
            :title="
              companyData.province +
                companyData.city +
                companyData.county +
                ' ' +
                accountData.address
            "
          >
            <img src="../../assets/imgs/commpany_map.png" />
            {{ companyData.province + companyData.city + companyData.county }}
            {{ accountData.address }}
          </span>
        </div>
      </div>
      <div class="right-box-right">
        <div>
          <el-tabs>
            <el-tab-pane label="服务信息">
              <div class="service-input">
                <el-form label-position="top" label-width="80px">
                  <el-form-item label="客服姓名">
                    <el-input
                      :disabled="true"
                      v-model="customer_service.customer_service_name"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="客服电话">
                    <el-input
                      :disabled="true"
                      v-model="customer_service.customer_service_tele"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="客服邮箱">
                    <el-input
                      :disabled="true"
                      v-model="customer_service.customer_service_email"
                    ></el-input>
                  </el-form-item>
                </el-form>
                <div v-if="advertisement.length" class="advertisement">
                  <el-carousel
                    height="182px"
                    arrow="never"
                    :interval="5000"
                    indicator-position="none"
                  >
                    <el-carousel-item
                      v-for="(item, i) in advertisement"
                      :key="i"
                    >
                      <img
                        :style="{
                          cursor: item.is_jump ? 'pointer' : 'default'
                        }"
                        :src="item.cover"
                        @click="goToLink(item)"
                      />
                    </el-carousel-item>
                    <!-- <div class="tag">广告</div> -->
                  </el-carousel>
                </div>
              </div>
              <img class="right-img" src="../../assets/imgs/right-b.png" />
            </el-tab-pane>
            <el-tab-pane label="账号信息">
              <div class="service-input">
                <el-form
                  style="position: relative;"
                  label-position="top"
                  label-width="80px"
                >
                  <div
                    v-show="!ismodifyAccount"
                    style="width: 100%;height: 100%;position: absolute;left:0;top:0;z-index: 998;"
                  ></div>
                  <el-form-item label="登录账号">
                    <el-input
                      :disabled="true"
                      v-model="accountData.account"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="账号密码">
                    <el-input
                      v-if="isEditPosword"
                      placeholder="请输入新密码"
                      v-model="posword"
                    ></el-input>
                    <el-input
                      :disabled="true"
                      v-else
                      v-model="morenposword"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="账号联系人" :required="true">
                    <el-input
                      id="nameVal"
                      v-model="accountData.nickname"
                    ></el-input>
                  </el-form-item>
                  <!-- <el-form-item label="个人简介">
                    <el-input v-model="accountData.intro" type="textarea"></el-input>
                  </el-form-item> -->
                  <el-form-item label="联系人电话" :required="true">
                    <el-input v-model="accountData.tele"></el-input>
                    <span
                      v-show="isRightNumber"
                      style="color:red;font-size:14px;"
                      >联系电话格式不正确,请重新填写</span
                    >
                  </el-form-item>
                  <el-form-item label="电子邮箱" :required="true">
                    <el-input v-model="accountData.email"></el-input>
                    <span
                      v-show="isRightemail"
                      style="color:red;font-size:14px;"
                      >邮箱格式不正确,请重新填写</span
                    >
                  </el-form-item>
                </el-form>
                <div class="primary-btn" v-show="ismodifyAccount">
                  <el-button @click="modifyAccountFun" type="primary"
                    >确认</el-button
                  >
                  <el-button @click="handleReturn">取消</el-button>
                </div>
                <el-button
                  class="edit-btn"
                  v-show="!ismodifyAccount"
                  @click="ismodifyAccount = true"
                  type="primary"
                  >编辑</el-button
                >
              </div>
            </el-tab-pane>
            <el-tab-pane label="公司信息">
              <div class="service-input">
                <el-form
                  style="position: relative;"
                  label-position="top"
                  label-width="80px"
                >
                  <div
                    v-show="!ismodifyCompany"
                    style="width: 100%;height: 100%;position: absolute;left:0;top:0;z-index: 998;"
                  ></div>
                  <el-form-item label="企业全称" :required="true">
                    <el-input
                      id="companyNameVal"
                      :disabled="true"
                      v-model="companyData.company_name"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="企业简称" :required="true">
                    <el-input
                      id="companyShortNameVal"
                      maxlength="6"
                      v-model="companyData.company_short"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="公司LOGO" :required="true">
                    <div class="backgroundinner-box">
                      <!-- <div class="img-backgroundinner">
                        <img v-if="companyData.logo" :src="imgHttp+companyData.logo" />
                        <img v-if="companyData.logo" :src="companyLogo" :onerror="defaultImgae" />
                        <img v-else src="../../assets/imgs/logo-back.png" />
                      </div>
                      <el-button v-show="ismodifyCompany" @click="ofDialog" plain>
                        {{companyData.logo?'修改LOGO':'上传LOGO'}}
                        <span style="color:red;position:absolute;right:15px;">*</span>
                      </el-button>-->

                      <!-- 改版上传图片 -->
                      <el-upload
                        class="imgbox"
                        name="image"
                        :action="actionadd()"
                        :show-file-list="false"
                        :on-success="handleLogoSuccess"
                        :before-upload="beforeAvatarUpload"
                      >
                        <img
                          v-if="companyData.logo"
                          :src="companyLogo"
                          :onerror="defaultImgae"
                        />
                        <img v-else src="../../assets/imgs/logo-back.png" />
                        <span v-show="ismodifyCompany">{{
                          companyData.logo ? "修改LOGO" : "上传LOGO"
                        }}</span>
                      </el-upload>
                      <div v-show="ismodifyCompany" class="tipbox">
                        <span>建议您使用1:1比例上传图片</span>
                        <span
                          >可上传的图片格式：jpg、png、jpeg，图片大小不可超过5M</span
                        >
                      </div>
                    </div>
                  </el-form-item>
                  <el-form-item
                    label="公司简介"
                    class="companytextarea"
                    :required="true"
                  >
                    <el-input
                      type="textarea"
                      show-word-limit
                      v-model="companyData.intro"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="公司规模" :required="true">
                    <el-select placeholder="请选择" v-model="companyData.scale">
                      <el-option
                        v-for="(item, i) in scale"
                        :key="i"
                        :label="item.name"
                        :value="item.id + ''"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="所属行业" :required="true">
                    <el-select
                      placeholder="请选择"
                      v-model="companyData.industry"
                    >
                      <el-option
                        v-for="(item, i) in industryOptions"
                        :key="i"
                        :label="item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="融资阶段">
                    <el-select
                      placeholder="请选择"
                      v-model="companyData.capitalization"
                    >
                      <el-option
                        v-for="(item, i) in capitalizationOptions"
                        :key="i"
                        :label="item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item
                    class="item-i"
                    label="公司福利"
                    :required="true"
                  >
                    <el-select
                      :multiple-limit="6"
                      multiple
                      collapse-tags
                      v-model="treatmentsArr"
                      value-key="id"
                      @change="getOption"
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="item in treatments"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                    <el-tag
                      v-for="(item, index) in treatmentsArr"
                      :key="index"
                      closable
                      :disable-transitions="false"
                      @close="handleClose(item)"
                      >{{ eachitem(item) }}</el-tag
                    >
                  </el-form-item>
                  <el-form-item
                    label="公司地址-省市区"
                    :required="true"
                    class="item-i"
                  >
                    <Address
                      ref="addressRef"
                      v-model="addressDetail"
                      style="widht:198px"
                    ></Address>
                  </el-form-item>
                  <el-form-item label="公司地址-详细地址" required>
                    <el-input
                      v-model="companyData.address"
                      placeholder="请输入详细地址"
                      style="width: 304px;"
                    ></el-input>
                  </el-form-item>
                </el-form>
                <div class="primary-btn" v-show="ismodifyCompany">
                  <el-button @click="modifyCompanyFun" type="primary"
                    >确认</el-button
                  >
                  <el-button @click="ismodifyCompany = false">取消</el-button>
                </div>
                <el-button
                  class="edit-btn"
                  v-show="!ismodifyCompany"
                  @click="ismodifyCompany = true"
                  type="primary"
                  >编辑</el-button
                >
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
    <template>
      <Dialog
        :dialogData="dialogData"
        @close-dialogStatus="Close_dialog"
      ></Dialog>
    </template>
  </div>
</template>
<script>
import Address from "@/components/Address";
import Dialog from "@/components/Dialog";
import Uploadimg from "@/components/uploadimg/index";
import Company from "@/api/CompanyModule";
import Treatments from "@/api/PublicModule";
export default {
  components: { Dialog, Uploadimg, Address },
  data() {
    return {
      addressDetail: [],
      defaultAvatarImgae:
        'this.src="' + require("../../assets/imgs/hello.png") + '"',
      defaultImgae:
        'this.src="' + require("../../assets/imgs/logo-back.png") + '"',
      companyLogo: "",
      isRightNumber: false,
      isRightemail: false,
      leftnikename: "",
      logo_back: require("../../assets/imgs/logo-back.png"),
      dialogData: {
        title: "公司LOGO", //弹窗名字
        dialogVisible: false, //关闭/打卡
        width: "460px", //弹窗宽度
        buttonNum: false, //
        isdisabled: true, //是否为禁用状态
        render: (h, scope) => {
          var that = this;
          return h(
            "div",
            {
              class: "updata-img-box"
            },
            [
              h(
                "div",
                {
                  class: "updata-img"
                },
                [
                  h(Uploadimg, {
                    props: {
                      size: {
                        width: 216,
                        height: 156
                      },
                      img: this.companyData.logo
                        ? this.formatDate(this.companyData.logo)
                        : this.logo_back
                    },
                    on: {
                      getimg($event) {
                        that.$nextTick(() => {
                          that.seritems($event);
                        });
                      }
                    }
                  }),
                  h("el-button", {
                    domProps: {
                      innerHTML: this.companyData.logo ? "修改LOGO" : "上传LOGO"
                    },
                    on: {
                      click: () => {
                        this.upImg();
                      }
                    }
                  })
                ]
              ),
              h("div", {
                class: "tip",
                domProps: {
                  innerHTML:
                    "可上传的图片格式：jpg、png、jpeg，图片大小不可超过5M"
                }
              })
            ]
          );

          // return (
          //     <div class="updata-img-box">
          //         <div class="updata-img">
          //             <div class="img-background">
          //                 <img src={this.companyData.logo?this.companyData.logo:this.logo_back} />
          //             </div>
          //             <el-button onClick={this.upImg}>{this.companyData.logo?'修改LOGO':'上传LOGO'}</el-button>
          //             <Uploadimg class="qqw"></Uploadimg>
          //         </div>
          //         <div class="tip">可上传的图片格式：jpg、png、jpeg，图片大小不可超过5M</div>
          //     </div>
          // )
        }
      },
      modifyIntroShow: true,
      accountData: {},
      companyData: {},
      customer_service: {},
      treatments: [],
      scale: [],
      industryOptions: [],
      capitalizationOptions: [],
      treatmentsArr: [],
      imgHttp: "",
      isEditPosword: false,
      posword: "",
      morenposword: "*********",
      ismodifyAccount: false,
      ismodifyCompany: false,
      formImg: "",
      advertisement: []
    };
  },
  watch: {
    ismodifyAccount() {
      if (this.ismodifyAccount) {
        this.isEditPosword = true;
        this.posword = "";
        document.getElementById("nameVal").focus();
      }
    },
    ismodifyCompany() {
      if (this.ismodifyCompany) {
        document.getElementById("companyShortNameVal").focus();
      } else {
        this.getCompanyData();
      }
    }
  },
  methods: {
    handleAvatarSuccess(res, file) {
      //上传头像
      this.accountData.avatar = URL.createObjectURL(file.raw);
      var data = {
        avatar: res.data.image
      };
      this.modifyAccountData(data, "auatar");
    },
    handleLogoSuccess(res, file) {
      //上传公司logo
      this.companyData.logo = res.data.image;
      this.companyLogo = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      const isJPG =
        file.type === "image/jpeg" ||
        file.type === "image/jpg" ||
        file.type === "image/png" ||
        file.type === "image/gif";
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isJPG) {
        this.$message.error("上传图片格式错误!");
      }
      if (!isLt5M) {
        this.$message.error("上传图片大小不能超过 5MB!");
      }
      return isJPG && isLt5M;
    },
    actionadd() {
      var api = ""; //process.env.VUE_APP_BASE_API
      return "/api/tool/upload/image";
    },
    // 取消个人信息修改
    handleReturn() {
      this.ismodifyAccount = false;
      this.isEditPosword = false;
      this.isRightNumber = false;
      this.isRightemail = false;
      this.getAccountData();
    },
    seritems(res) {
      this.dialogData["isdisabled"] = false;
      this.formImg = res.data.image;
      this.imgHttp = res.data.host;
    },
    upImg() {
      var upimgClass = document.getElementsByClassName("el-upload__input")[0];
      upimgClass.click();
    },
    reload() {
      //组件刷新
      this.isLoad = false;
      this.$nextTick(() => {
        this.isLoad = true;
      });
    },
    handleClose(tag) {
      this.treatmentsArr.splice(this.treatmentsArr.indexOf(tag), 1);
      if (!this.treatmentsArr.length) {
        // document.getElementsByClassName("el-select__tags")[0].innerHTML = "";
      }
    },
    modifyAccountFun() {
      //修改个人信息
      const phoneReg = /^((\d{11})|^((\d{7,8})|(\d{4}|\d{3})-(\d{7,8})|(\d{4}|\d{3})-(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1})|(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1}))$)$/;
      const emailReg = /[\@]/;
      if (!phoneReg.test(this.accountData.tele)) {
        this.isRightNumber = true;
      } else if (!emailReg.test(this.accountData.email)) {
        this.isRightemail = true;
      } else {
        this.isRightNumber = false;
        this.isRightemail = false;
        // this.ismodifyAccount = false;
        var data = {
          // intro: this.accountData.intro,
          email: this.accountData.email,
          nickname: this.accountData.nickname,
          tele: this.accountData.tele
          // password: this.posword
        };
        if (
          this.accountData.email != "" &&
          this.accountData.nickname != "" &&
          this.accountData.tele != ""
        ) {
          if (this.posword) {
            data["password"] = this.posword;
          }
          this.modifyAccountData(data);
        } else {
          this.$message.error("请完善您的个人信息");
        }
      }
    },
    modifyCompanyFun() {
      console.table(this.companyData);
      let [province, city, county] = this.addressDetail;
      const noChildrenNameArr = ["香港特别行政区", "澳门特别行政区", "台湾省"];
      if (noChildrenNameArr.includes(province)) {
        city = "";
        county = "";
      }
      //修改公司信息
      var data = {
        company_name: this.companyData.company_name,
        company_short: this.companyData.company_short,
        logo: this.formatDate(this.companyData.logo),
        intro: this.companyData.intro,
        capitalization: this.companyData.capitalization,
        scale: this.companyData.scale,
        address: this.companyData.address,
        treatments: this.treatmentsArr,
        province,
        city,
        county,
        industry: this.companyData.industry
      };
      if (
        this.companyData.company_name != "" &&
        this.companyData.company_short != "" &&
        this.formatDate(this.companyData.logo) != "" &&
        this.companyData.intro != "" &&
        this.companyData.scale != "" &&
        this.companyData.address != "" &&
        this.treatmentsArr != "" &&
        this.companyData.industry &&
        this.addressDetail.length
      ) {
        if (!this.companyData.capitalization) {
          delete data["capitalization"];
        }
        console.log("modify params---", data);
        Company.modifyCompany(data)
          .then(res => {
            this.$message({
              message: "修改成功",
              type: "success"
            });
            var account_little_intro = JSON.parse(
              localStorage.getItem("account")
            );
            account_little_intro.company_name = res.data.data.company_name;
            account_little_intro.address = res.data.data.address;
            localStorage.setItem(
              "account",
              JSON.stringify(account_little_intro)
            );
            this.getAccountData();
            this.$emit("load");
            this.ismodifyCompany = false;
          })
          .catch(err => {
            if (err.data.status === 201) {
              this.$message.error("请您完善公司信息");
            }
          });
      } else {
        this.$message.error("请您完善公司信息");
      }
    },
    Close_dialog(value) {
      this.companyData.logo = this.formImg;
      this.companyLogo = this.imgHttp + this.formImg;
      this.dialogData["dialogVisible"] = value;
    },
    ofDialog() {
      this.dialogData["dialogVisible"] = true;
    },
    modifyIntro() {
      this.modifyIntroShow = false;
      this.$nextTick(function() {
        document.getElementById("inputVal").focus();
      });
    },
    modifyIntroHide() {
      this.modifyIntroShow = true;
      var data = {
        little_intro: this.accountData.little_intro
      };
      this.modifyAccountData(data, "little_intro");
    },
    getAccountData() {
      //获取账号信息
      var that = this;
      that.accountData = JSON.parse(localStorage.getItem("account"));
      that.leftnikename = that.accountData.nickname;
    },
    getOption(e) {
      // var divtag = "<div style='line-height:0'>请选择</div>";
      // document.getElementsByClassName("el-select__tags")[0].innerHTML = divtag;
    },
    eachitem(el) {
      for (var i = 0; i < this.treatments.length; i++) {
        if (this.treatments[i].id === el) {
          return this.treatments[i].name;
        }
      }
    },
    modifyAccountData(data, is) {
      Company.modifyAccount(data)
        .then(res => {
          this.$message({
            message: "修改成功",
            type: "success"
          });
          var account_little_intro = JSON.parse(
            localStorage.getItem("account")
          );
          var newRes = res.data.data;
          newRes.account = account_little_intro.account;
          newRes.address = account_little_intro.address;
          newRes.role_name = account_little_intro.role_name;
          newRes.company_name = account_little_intro.company_name;
          newRes.menu_detail = account_little_intro.menu_detail;
          localStorage.setItem("account", JSON.stringify(newRes));
          if (is === "auatar") {
            this.$emit("load", 1);
            return;
          }
          if (is !== "little_intro") {
            this.getAccountData();
            this.$emit("load");
            this.handleReturn();
          }
        })
        .catch(err => {
          this.$message.error(err.data.error);
          this.getAccountData();
        });
    },
    formatDate(is) {
      return is.replace("http://s.laoyaoba.com/", "");
    },
    account() {
      this.getAccountData();
    },
    //获取公司信息
    getCompanyData() {
      this.treatmentsArr = [];
      Company.getCompany()
        .then(res => {
          this.companyData = res.data.data;
          if (!this.companyData.capitalization) {
            delete this.companyData.capitalization;
          }
          const { province, city, county } = res.data.data;
          this.addressDetail = [];
          province && this.addressDetail.push(province);
          city && this.addressDetail.push(city);
          county && this.addressDetail.push(county);
          console.log(this.addressDetail);
          this.companyData.scale =
            this.companyData.scale === 0 ? "9" : this.companyData.scale + "";
          res.data.data.treatments.forEach(element => {
            this.treatmentsArr.push(element.id);
          });
          this.customer_service = this.companyData.customer_service;
          this.companyLogo = this.imgHttp + this.companyData.logo;
        })
        .catch(err => {
          console.log(err);
        });
    },
    getAdvertisement() {
      Treatments.getAdvertisement()
        .then(res => {
          this.advertisement = res.data.data;
        })
        .catch(err => {
          console.log(err);
        });
    },
    goToLink(scope) {
      const { is_jump, url } = scope;
      if (is_jump) {
        window.open(url);
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (from.path !== "/login") {
        vm.getAccountData();
      } else {
        vm.$emit("getNoticeMessage");
      }
    });
  },
  mounted() {
    this.getOption();
    this.getAdvertisement();
    this.getCompanyData(); //获取公司信息
    Treatments.getPublicFormList() //获取福利。。。等公共信息
      .then(res => {
        this.treatments = res.data.data.treatments;
        this.scale = res.data.data.scale;
        this.capitalizationOptions = res.data.data.capitalize;
        this.industryOptions = res.data.data.industry;
      })
      .catch(err => {
        console.log(err);
      });
  }
};
</script>
<style>
.companytextarea .el-textarea {
  width: 530px;
}
.right-box .right-box-right .el-button--primary {
  margin-bottom: 50px;
}
.right-box .el-select__tags {
  height: 40px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  padding-left: 16px;
  color: #c0c4cc;
}
/* .right-box .el-select__tags > span {
  display: none !important;
} */
.right-box .el-tabs__nav {
  margin-left: 30px;
}
.right-box .el-tabs__item {
  padding: 0 25px;
  height: 58px;
  line-height: 58px;
  font-size: 16px;
  color: #888888;
}
.right-box .el-tabs__nav-wrap::after {
  height: 1px;
  background-color: #f5f6f9;
}
.right-box .el-tabs__active-bar {
  height: 4px;
  border-radius: 2px;
  background-color: #0077ff;
}
.right-box .el-tabs__item:hover {
  color: #333333;
}
.right-box .el-tabs__item.is-active {
  color: #333333;
}
.right-box .el-form-item__label {
  color: #333333;
}
.right-box .el-form--label-top .el-form-item__label {
  padding: 0;
}
.right-box .el-form-item__content {
  width: 304px;
}
.right-box .el-form-item {
  margin-bottom: 15px;
}
.right-box .el-textarea__inner {
  width: 530px;
  height: 124px;
  resize: none;
}
.right-box .el-button.is-plain:focus,
.el-button.is-plain:hover {
  background: #fff;
  border-color: #0077ff;
  color: #0077ff;
}
.right-box .item-i .el-form-item__content {
  width: 100%;
}
.right-box .el-tag {
  /* height: 39px;
  line-height: 39px;
  margin-left: 10px; */
}
.right-box .el-tab-pane {
  min-height: 663px;
  position: relative;
}
.right-box .updata-img {
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  align-items: center;
  -webkit-align-items: center;
}
.right-box .img-background {
  width: 216px;
  height: 156px;
  border: 1px dashed #e2ebf7;
}
.backgroundinner-box {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
}
.right-box .img-backgroundinner {
  width: 140px;
  height: 101px;
  margin-right: 20px;
  border: 1px dashed #e2ebf7;
}
.right-box .img-backgroundinner img {
  width: 100%;
  height: 100%;
}
.right-box .img-background img {
  width: 100%;
  height: 100%;
}
.right-box .updata-img-box {
  margin: 25px 40px;
}
.right-box .tip {
  margin-top: 14px;
  font-size: 12px;
  text-align: left;
}
.el-textarea .el-input__count {
  line-height: 1;
}
.imgbox .el-upload {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  border: 1px dashed #e2ebf7;
  overflow: hidden;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  -webkit-justify-content: center;
  align-items: center;
  -webkit-align-items: center;
}
</style>
<style scoped>
.imgbox {
  width: 100px;
  height: 100px;
  position: relative;
}
.imgbox img {
  height: 100%;
  position: absolute;
}
.imgbox span {
  position: absolute;
  z-index: 999;
  line-height: 20px;
  background-color: #409eff;
  border-radius: 60px;
  padding: 0 10px;
  color: #fff;
  font-size: 12px;
  cursor: pointer;
}
.tipbox {
  width: 400px;
  height: 100px;
  margin-left: 10px;
  font-size: 12px;
  color: #aaaaaa;
  position: absolute;
  left: 110px;
  top: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.redspan {
  color: red;
  position: absolute;
  left: 105px;
}
.tipbox span {
  line-height: 20px;
}
.right-box {
  display: flex;
  display: -webkit-flex;
  min-height: 100%;
}
.right-box > div {
  margin-top: 20px;
  display: flex;
  display: -webkit-flex;
}
.right-box-left {
  width: 235px;
  background-color: #fff;
  border-radius: 5px;
}
.right-box-right {
  width: 818px;
  margin-left: 10px;
  background-color: #fff;
  border-radius: 5px;
}
.right-box-left > div {
  margin-top: 43px;
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  -webkit-flex-direction: column;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  align-items: center;
  -webkit-align-items: center;
}
.right-box-left .avatar span {
  display: block;
  margin-top: 6px;
  width: 80px;
  height: 26px;
  background: #ffffff;
  border-radius: 3px;
  color: #666666;
  border: 1px solid #e7e7e7;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  cursor: pointer;
  position: relative;
}
.right-box-left .top .avatar span > img {
  margin: 0 5px;
  width: 14px;
  height: 12px;
}
.right-box-left .avatar > img {
  width: 80px;
  height: 80px;
  border-radius: 100%;
}
.right-box-left .top .intro {
  margin-top: 20px;
  color: #333333;
  text-align: center;
  width: 225px;
}
.right-box-left .top,
.bottom span {
  margin-top: 6px;
  font-size: 12px;
  color: #666666;
  line-height: 16px;
}
.right-box-left .bottom span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.right-box-left .top .intro span > img {
  margin: 0 5px;
  position: relative;
  top: 4px;
  width: 12px;
  height: 11px;
  cursor: pointer;
}

.right-box-left .top .nikename {
  display: inline-block;
  height: 21px;
  font-size: 16px;
  color: #333333;
  line-height: 21px;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 100%;
  overflow: hidden;
}
.right-box-left .top .spanbox {
  width: 100%;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  -webkit-justify-content: center;
  font-size: 12px;
  color: #666666;
  margin-top: 6px;
  line-height: 16px;
}
.right-box-left .top,
.bottom img {
  margin: 0 5px;
  position: relative;
  top: 2px;
}
.right-box-left .bottom {
  height: 88px;
  margin-top: 42px;
  padding: 0px 20px;
}
.right-box-left .bottom span {
  width: 100%;
  text-align: left;
}
.service-input {
  margin-left: 30px;
  height: 100%;
  position: relative;
}
.advertisement {
  width: 437px;
  height: 182px;
  position: absolute;
  right: 30px;
  top: 40px;
}
.advertisement img {
  width: 100%;
  height: 100%;
}
.advertisement .tag {
  width: 44px;
  height: 24px;
  line-height: 24px;
  background: rgba(0, 0, 0, 0.4);
  border-radius: 3px;
  position: absolute;
  z-index: 999;
  right: 8px;
  bottom: 8px;
  color: #fff;
  font-size: 12px;
  text-align: center;
}
.right-img {
  position: absolute;
  bottom: 0;
  right: 0;
}
.edit-btn {
  width: 140px;
  height: 46px;
  position: absolute;
  right: 30px;
  top: 0;
  z-index: 999;
}
.primary-btn button {
  width: 136px;
  height: 43px;
  margin-top: 60px;
}
</style>



// WEBPACK FOOTER //
// src/views/my/mymsg.vue